export const setFilterQueryParams = (filters, pathname, history, replaceRoute) => {
  const searchParams = new URLSearchParams()
  Object.entries(filters).forEach(([key, value]) => {
    searchParams.delete(key)
    searchParams.set(key, JSON.stringify(value))
  })
  const queryString = searchParams.toString()
  const route = `${pathname}${queryString ? `?${queryString}` : ''}`
  if (replaceRoute) {
    history.replace(route)
  } else {
    history.push(route)
  }
}
